import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines class names with Tailwind merge support.
 * Standard shadcn/ui utility — используется во всех UI компонентах.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
